// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.redlining-controlsbar {
    display: flex;
    margin: 0.25em 0;
}

div.redlining-groupcontrol {
    flex: 0 0 auto;
}

div.redlining-groupcontrol:not(:last-child) {
    margin-right: 0.25em;
}

div.redlining-groupcontrol > div:first-child {
    font-size: 85%;
    text-align: center;
}

div.redlining-export-menu-entry {
    font-size: 90%;
}

div.redlining-control {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    margin: 0 0.125em;
}

div.redlining-control-fill {
    flex: 1 1 auto;
}

div.redlining-control-fill > div.controlgroup {
    flex: 1 1 auto;
}

span.redlining-control-icon {
    margin-right: 0.125em;
}

div.redlining-marker-combo-entry {
    display: flex;
    align-items: center;
    height: 16px;
    width: 16px;
}

div.redlining-marker-combo-entry img {
    /* Marker images are white, invert them to black */
    filter: invert(1);
    height: 100%;
}

div.redlining-message {
    font-size: 90%;
    text-align: center;
    font-style: italic;
}

div.redlining-dash-combo-entry {
    display: flex;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./plugins/style/Redlining.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kDAAkD;IAClD,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":["div.redlining-controlsbar {\n    display: flex;\n    margin: 0.25em 0;\n}\n\ndiv.redlining-groupcontrol {\n    flex: 0 0 auto;\n}\n\ndiv.redlining-groupcontrol:not(:last-child) {\n    margin-right: 0.25em;\n}\n\ndiv.redlining-groupcontrol > div:first-child {\n    font-size: 85%;\n    text-align: center;\n}\n\ndiv.redlining-export-menu-entry {\n    font-size: 90%;\n}\n\ndiv.redlining-control {\n    display: flex;\n    flex: 0 0 auto;\n    align-items: center;\n    justify-content: center;\n    margin: 0 0.125em;\n}\n\ndiv.redlining-control-fill {\n    flex: 1 1 auto;\n}\n\ndiv.redlining-control-fill > div.controlgroup {\n    flex: 1 1 auto;\n}\n\nspan.redlining-control-icon {\n    margin-right: 0.125em;\n}\n\ndiv.redlining-marker-combo-entry {\n    display: flex;\n    align-items: center;\n    height: 16px;\n    width: 16px;\n}\n\ndiv.redlining-marker-combo-entry img {\n    /* Marker images are white, invert them to black */\n    filter: invert(1);\n    height: 100%;\n}\n\ndiv.redlining-message {\n    font-size: 90%;\n    text-align: center;\n    font-style: italic;\n}\n\ndiv.redlining-dash-combo-entry {\n    display: flex;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
